/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext, useRef } from 'react'
import TextSection from '../../../../../components/ToolTip/TextSection'
import { Link, useParams } from 'react-router-dom'
import { dataService } from '../../../../../services/data.services';
import moment from 'moment';
import AttendanceDropdown from './AttendanceDropdown';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import ViewAttendanceShimmer from '../../../../../components/Shimmer/ViewAttendanceShimmer';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';


const ViewIndividualAttendance = ({type}) => {
    const BackParameters = new URLSearchParams(window.location.search).toString();
    const { setToastmessage, isSideNavBar, UpdateCall, setUpdateCall, isInactiveBranch, setToastErrorMessage } = useContext(GlobalContext)
    const { id, name, number } = useParams();
    const [attendanceRecords, setAttendanceRecords] = useState([])
    const [modifiedRecord, setModifiedRecord] = useState(null); // Track the modified record
    const [queryParams, setQueryParams] = useState({})
    const [tempList, setTempList] = useState([])
    const [openDropdownIndex, setOpenDropdownIndex] = useState(-1);
    const [selectedSession, setSelectedSession] = useState("");
    const [hover, sethover] = useState('')
    const [hoverIndex, sethoverIndex] = useState(null)
    const [loading, setLoading] = useState(true)
    const [staffOrStudentDetails, setDetails] = useState({})


    const outsideClickRef1 = useRef();
    const outsideClickRef2 = useRef();

    function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const isHolidayStatus = (value) => value?.toLowerCase() === 'holiday';

    useOnClickOutside(outsideClickRef1, () => {
        setOpenDropdownIndex(false);
        setSelectedSession("")

    });
    useOnClickOutside(outsideClickRef2, () => {
        setOpenDropdownIndex(false);
        setSelectedSession("")

    });

    const [isClockOut, setIsClockOut] = useState({})
    const handleFetchStudentAttendance = async (params) => {
        if (type === "staff") {
            delete params.fy_status;
            // Change employee_type to staff_type if employee_type exists, then delete it
            if (params.employee_type) {
                params.staff_type = params.employee_type;
                delete params.employee_type;
            } else{
                delete params.employee_type;
            }
        }
        delete params.academic_year
        delete params.class_name
        const queryParameters = Object.entries(params)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        const branch_id = await GetBranchId()
        try {
            const response = await dataService.GetAPI(`${type === "staff" ? "staff-attendance" : "student-attendance"}?branch_id=${branch_id}&${type === "staff" ? "employee_id=" : "student_id="}${id}&${queryParameters}`);
            if (response.data.status === 200) {
                
                setAttendanceRecords(response.data.data.data)
                setDetails(response.data.data.student_details || response.data.data.employee_details)
                setIsClockOut(type === "staff" ? {"clock_in_out" : response.data.data.clock_in_out, "financial_year_status" : response.data.data.financial_year_status} : {"academic_year_status" : response.data.data.academic_year_status})
                setLoading(false);
            }
        } catch (error) {
            setLoading(true);
        }
    }


    const [originalRecord, setOriginalRecord] = useState(null);
    const handleModifyAttendance = (item, rowIndex) => {
        if (rowIndex === openDropdownIndex) {
            const original = { ...item }; // Create deep copy
            setOriginalRecord(original); // Save deep copy of the initial state
        }
        setTempList((prev) => [...prev, rowIndex]);
    };
    
    const handleDropdownSelect = (index, session) => {
        if (isHolidayStatus(attendanceRecords[index]?.[session])) {
            return;
        }
        if (openDropdownIndex !== index && !originalRecord) {
            setOriginalRecord({ ...attendanceRecords[index] });
        }
        setSelectedSession(session);
        setOpenDropdownIndex(openDropdownIndex === index ? -1 : index);
    };
    
    const handleDropdownChange = (index, item, session, value) => {
        const updatedRecords = [...attendanceRecords];
        const recordToUpdate = updatedRecords[index];
        if (recordToUpdate) {
            if (openDropdownIndex === index && session === 'first_half') {
                recordToUpdate.first_half = value;
            }
            if (openDropdownIndex === index && session === 'second_half') {
                recordToUpdate.second_half = value;
            }
            setModifiedRecord({ ...recordToUpdate });
        }
        setAttendanceRecords(updatedRecords);
        setOpenDropdownIndex(false);
    };
    
    const handleCancel = (index) => {
        if (originalRecord) {
            const updatedRecords = [...attendanceRecords];
            updatedRecords[index] = { ...originalRecord }; // Restore both fields from original state
            setAttendanceRecords(updatedRecords);
            setOriginalRecord(null); // Clear saved state after cancel
        }
        setTempList(tempList.filter((item) => item !== index));
        setOpenDropdownIndex(-1);
    };

    const handleSubmit = async (index, selectedItem) => {
        setLoading(true)
        if (modifiedRecord) {
            let body =
            {
                "first_half": modifiedRecord.first_half,
                "second_half": modifiedRecord.second_half,
                "date": moment(selectedItem.date).format("YYYY-MM-DD"),
                "branch_id": staffOrStudentDetails.branch_id,
            }
            
            if(type === "staff") {
                body["employee_ids"] = [staffOrStudentDetails.employee_id]
            } else {
                body["academic_year_id"] = staffOrStudentDetails.academic_year_id,
                body["class_id"] =staffOrStudentDetails.class_id,
                body["section_id"] = staffOrStudentDetails.section_id,
                body["student_ids"] = [staffOrStudentDetails.student_uuid];
            }
            try {
                const res = await dataService.PutAPI(body, type === "staff" ? "staff-attendance" : 'student-attendance')
                if (!res.error) {
                    setLoading(false)
                    setToastmessage('Attendance Modified Successfully')
                } else {
                    setLoading(false)
                    setToastmessage('Something went Wrong')
                }
                setTempList(tempList.filter((item) =>
                    item !== index))
                handleFetchStudentAttendance(queryParams)
                setModifiedRecord(null);
                setTempList([])
                setLoading(false)

            } catch (error) {
                setLoading(false)
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }
        } else {
            setTempList(tempList.filter((item) =>
                item !== index))
            setLoading(false)

        }
    }
    
    const fetchUrlData = () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        delete params.start_date;
        delete params.end_date;
        delete params.page_number;
        delete params.limit;
        setQueryParams(params);
        handleFetchStudentAttendance(params);
    };
    const [fyStatus, setFyStatus] = useState("")
    const getFYStatus = () => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // Get the fy_status parameter
        const fyStatus = params.get('fy_status');
        setFyStatus(fyStatus)
    }

    useEffect(() => {
        getFYStatus()
        fetchUrlData()
    }, []);

    return (
        <div class={` w-full main-screenInst overflow-x-hidden max-h-screen min-h-screen relative ${!isSideNavBar ? 'w-[270px]' : ''}`} >
            <div className={`mainDataCntnr ${!isSideNavBar ? 'normal' : 'wide'}`}>
                <div class="mainDataCntnrTop shadow-s13" style={{ position: 'sticky', position: '-webkit-sticky' }}>
                    <div class="flex items-center">
                        <Link to={type === "staff" ? `/employee-master/employee-attendance?${BackParameters}` : `/student-master/student-attendance?${BackParameters}`}>
                            <img src="/images/back-btnBlue.svg" alt="icon" />
                        </Link>
                        <h5 class="pageHeader ml-2.5 adderror">{type === "staff" ? "Employee" : "Student"} Attendance Details</h5>
                    </div>
                </div>
                {loading
                    ? <ViewAttendanceShimmer classkey='w-[60%] mx-auto mt-5' />
                    :
                    (<div class="mainDataCntnrPageDiv scrollBlue_thick">
                        <div class="2xl:w-[55%] w-[65%] mx-auto " >
                            <div class="pr-[50px] -mx-1">
                                <div class="px-1">
                                    <div class="flex justify-between px-2.5">
                                        <div class="flex items-center">
                                            <p class="text-f7 font-normal text-[#031624] min-w-max">{type === "staff" ? "Employee" : "Student"} Name:</p>
                                            <p class="text-f7 font-semibold text-[#031624] ml-[3px] max-w-[95%] flex items-center " title={name}>
                                                <span class="more-lines break-words min-w-[auto] max-w-[75%]">{name}</span>
                                                <span class="w-[30%] ml-[2px]">[{type === "staff" ? number : id}]</span>
                                                {(type === "staff" && !staffOrStudentDetails.employee_status) &&
                                                    <><div class="w-fit rounded bg-[#B3BBC1] flex items-center justify-center py-1 px-2.5 ml-2">
                                                        <img loading="lazy" decoding="async" src="/images/inactive-Dot.svg" alt="icon"/>
                                                        <span class="text-f7 font-normal text-[#031624] pl-1">Inactive</span>
                                                    </div></>
                                                }
                                                {(type !== "staff" && staffOrStudentDetails.student_status && staffOrStudentDetails.student_status != "active") &&
                                                    <><div class="w-fit rounded bg-[#B3BBC1] flex items-center justify-center py-1 px-2.5 ml-2">
                                                        <img loading="lazy" decoding="async" src="/images/inactive-Dot.svg" alt="icon"/>
                                                        <span class="text-f7 font-normal text-[#031624] pl-1">${staffOrStudentDetails.student_status}</span>
                                                    </div></>
                                                }
                                            </p>
                                        </div>
                                        <div class="flex items-center">
                                            <p class="text-f7 font-semibold text-[#031624] ml-[26px] min-w-max">{queryParams.month.slice(0, 3)} {queryParams.year}</p>
                                        </div>
                                    </div>
                                    <div class="flex mb-3 pr-2 pb-2.5 px-1 mt-2">
                                        <table aria-label="Outside Table" class="w-full" id="admin-table">
                                            <thead>
                                                <tr>
                                                    <th class="w-[20%]">
                                                        <span >Date
                                                        </span>
                                                    </th>
                                                    <th class="w-[30%] ">
                                                        <span >First Half
                                                        </span>
                                                    </th>
                                                    <th class="w-[30%] ">
                                                        <span >Second Half
                                                        </span>
                                                    </th>
                                                    <th class="w-[20%] ">
                                                        <span class="flex items-center justify-center">Action
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr aria-colspan="7" class="h-1">
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attendanceRecords.map((item, index) => (
                                                    <>
                                                        <tr key={item._id}>
                                                            <td class="text-start ">
                                                                {moment(item?.date).format('MMM DD, YYYY')}
                                                            </td>
                                                            <td class="text-start">
                                                                <div>
                                                                    {!tempList.includes(index) ?
                                                                        <span class="edit_value">{capitalizeFirstLetter(item.first_half)}</span>
                                                                        :
                                                                        <div ref={outsideClickRef1} class="relative w-[110px] edit_value1" data-te-dropdown-ref>
                                                                            <button
                                                                                class={`w-full rounded bg-white px-3.5 pr-[28px] outline-0 text-f7 text-left font-normal transition duration-150 ease-in-out border border-[#C2DCEF] ${isHolidayStatus(attendanceRecords[index].first_half) ? 'cursor-not-allowed text-[#A0AAB4] bg-[#F5F7F9]' : 'text-[#031624]'}`}
                                                                                type="button"
                                                                                id="first_half"
                                                                                data-te-dropdown-toggle-ref aria-expanded="false"
                                                                                disabled={isHolidayStatus(attendanceRecords[index].first_half)}
                                                                                onClick={() => { handleDropdownSelect(index, "first_half") }}
                                                                            >
                                                                                <p class="text-f7 text-[#000000] font-normal">{capitalizeFirstLetter(attendanceRecords[index].first_half)}</p>
                                                                                {!isHolidayStatus(attendanceRecords[index].first_half) &&
                                                                                    <img loading="lazy" decoding="async" src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${selectedSession === "first_half" && openDropdownIndex === index ? 'transform rotate-180' : ''}`} />
                                                                                }
                                                                            </button>
                                                                            {selectedSession === "first_half" && openDropdownIndex === index &&
                                                                                <AttendanceDropdown
                                                                                    handleDropdownChange={handleDropdownChange}
                                                                                    session={"first_half"}
                                                                                    selectedItem={item}
                                                                                    selectedIndex={index}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td class="text-start">
                                                                <div>
                                                                    {!tempList.includes(index) ?
                                                                        <span class="edit_value">{capitalizeFirstLetter(item.second_half)}</span>
                                                                        :
                                                                        <div ref={outsideClickRef2} class="relative w-[110px] edit_value1" data-te-dropdown-ref>
                                                                            <button
                                                                                class={`w-full rounded bg-white px-3.5 pr-[28px] outline-0 text-f7 text-left font-normal transition duration-150 ease-in-out border border-[#C2DCEF] ${isHolidayStatus(attendanceRecords[index].second_half) ? 'cursor-not-allowed text-[#A0AAB4] bg-[#F5F7F9]' : 'text-[#031624]'}`}
                                                                                type="button"
                                                                                id="second_half"
                                                                                data-te-dropdown-toggle-ref aria-expanded="false"
                                                                                disabled={isHolidayStatus(attendanceRecords[index].second_half)}
                                                                                onClick={() => handleDropdownSelect(index, "second_half")}
                                                                            >
                                                                                <p class="text-f7 text-[#000000] font-normal">{capitalizeFirstLetter(attendanceRecords[index].second_half)}</p>
                                                                                {!isHolidayStatus(attendanceRecords[index].second_half) &&
                                                                                    <img loading="lazy" decoding="async" src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${selectedSession === "second_half" && openDropdownIndex === index ? 'transform rotate-180' : ''}`} />
                                                                                }
                                                                            </button>
                                                                            {selectedSession === "second_half" && openDropdownIndex === index &&
                                                                                <AttendanceDropdown
                                                                                    handleDropdownChange={handleDropdownChange}
                                                                                    session={"second_half"}
                                                                                    selectedItem={item}
                                                                                    selectedIndex={index}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td class="text-center">
                                                                <div class="relative">
                                                                    {!tempList.includes(index) &&
                                                                        <>
                                                                            <>{hover === 'modify' && (hoverIndex === index) &&
                                                                                <div className='relative top-[55px] -left-12'>
                                                                                    <TextSection text='Modify Attendance' show from={'academicreports'} />
                                                                                </div>}
                                                                            </>
                                                                            <button
                                                                                id='view'
                                                                                class={`edit_value`}
                                                                                data-tooltip-target="panuploadInfo"
                                                                                data-tooltip-trigger="hover"
                                                                                data-tooltip-placement="top"
                                                                                type="button"
                                                                                className={`edit_value ${isInactiveBranch?"img-disable":""}`}
                                                                                disabled={(type === "staff" ? (moment(item.date).isSame(moment(), 'day') && isClockOut.clock_in_out) || (isClockOut.financial_year_status !== "ongoing" && isClockOut.financial_year_status !== "open") || !(staffOrStudentDetails.employee_status) : isClockOut.academic_year_status === "completed") || isInactiveBranch || (staffOrStudentDetails.student_status && staffOrStudentDetails.student_status != "active")}
                                                                                onMouseEnter={() => { sethover('modify'), sethoverIndex(index) }}
                                                                                onMouseLeave={() => { sethover(''), sethoverIndex(null) }}
                                                                                onClick={() => handleModifyAttendance(item, index)}
                                                                            >
                                                                                <img loading="lazy" decoding="async" src="/images/offcanvasEditDetails.svg" alt="img" id="modify_attendance" className="w-4 h-4"/>
                                                                            </button>

                                                                        </>
                                                                    }
                                                                    {tempList.includes(index) &&
                                                                        <div class="edit_table_value flex items-center ml-[25px]">
                                                                            <div className='relative'>
                                                                                <>{hover === 'update' && (hoverIndex === index) &&
                                                                                    <div className='absolute top-[55px] -left-4'>
                                                                                        <TextSection text='Update' show from={'academicreports'} />
                                                                                    </div>}
                                                                                </>
                                                                                <button
                                                                                    id='tick-mark'
                                                                                    type="button"
                                                                                    class="px-1.5"
                                                                                    onMouseEnter={() => { sethover('update'), sethoverIndex(index) }}
                                                                                    onMouseLeave={() => { sethover(''), sethoverIndex(null) }}
                                                                                    onClick={() => handleSubmit(index, item)}
                                                                                >
                                                                                    <img loading="lazy" decoding="async" src="/images/otp-tick.svg" alt="img" class="w-5 h-5 update_btn" />
                                                                                </button>
                                                                            </div>
                                                                            <div className='relative'>
                                                                                <>{hover === 'cancel' && (hoverIndex === index) &&
                                                                                    <div className='absolute top-[55px] -left-5'>
                                                                                        <TextSection text='Cancel' show from={'academicreports'} />
                                                                                    </div>}
                                                                                </>
                                                                                <button
                                                                                    type="button"
                                                                                    class="px-1.5"
                                                                                    onMouseEnter={() => { sethover('cancel'), sethoverIndex(index) }}
                                                                                    onMouseLeave={() => { sethover(''), sethoverIndex(null) }}
                                                                                    onClick={() => handleCancel(index)}
                                                                                >
                                                                                    <img loading="lazy" decoding="async" src="/images/file-remove.svg" alt="img" class="w-5 h-5" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        
                                                    </>
                                                ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    )
}

export default ViewIndividualAttendance